import React from "react";
import { Empty, Divider } from "antd";
import { FileListItem } from "@/components/FileListItem/FileListItem";
import type { UploadFile } from "antd";
import { useTranslation } from "react-i18next";

// ==================== 类型定义 ====================

interface SolutionFile {
  id?: string | number;
  fileName: string;
  fileUrl: string;
  remark?: string;
  fileType: string;
}

interface SolutionFileDisplayProps {
  files?: SolutionFile[];
}

// ==================== 主组件 ====================

const SolutionFileDisplay: React.FC<SolutionFileDisplayProps> = ({
  files = [],
}) => {
  const { t } = useTranslation("supplierRiskLevel");

  // 过滤出 fileType 为 "solutionFile" 的文件
  const solutionFiles = files.filter(
    (file) => file.fileType === "solutionFile",
  );

  if (solutionFiles.length === 0) {
    return <Empty description={t("暂无解决方案文件")} />;
  }

  return (
    <div style={{ marginTop: "12px" }}>
      {solutionFiles.map((file, index) => (
        <div
          key={`solution-file-${file.id || index}`}
          style={{ marginBottom: "16px" }}
        >
          {/* 文件项 */}
          <FileListItem
            file={
              {
                uid: file.id || file.fileUrl,
                name: file.fileName || file.fileUrl.split("/").pop() || "文件",
                status: "done" as const,
                url: file.fileUrl,
                fileId: file.id,
              } as UploadFile
            }
            hiddenRemove={true}
          />

          {/* 备注说明 */}
          {file.remark && (
            <div
              style={{
                marginTop: "8px",
                padding: "8px 12px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
                fontSize: "14px",
                color: "#666",
              }}
            >
              <div
                style={{ fontWeight: 500, marginBottom: "4px", color: "#333" }}
              >
                {t("备注说明")}
              </div>
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {file.remark}
              </div>
            </div>
          )}

          {/* 分隔线 */}
          {index < solutionFiles.length - 1 && (
            <Divider style={{ margin: "12px 0" }} />
          )}
        </div>
      ))}
    </div>
  );
};

export default SolutionFileDisplay;
